module.exports = __webpack_public_path__ + "img/wordmark-white.fa5dc4e9.svg";